import template from './version.html';
import controller from './version.controller';
import './version.scss';

let versionComponent = {
  bindings: {},
  template,
  controller
};

export default versionComponent;



// WEBPACK FOOTER //
// ./client/app/components/version/version.component.js